import { THEME_COOKIE } from '@/shared/constants/theme';
import { Theme } from '@/shared/types/user';

const DEFAULT_THEME: Theme = 'light';

const isTheme = (value: unknown): value is Theme => value === 'dark' || value === 'light';

export const resolveTheme = (value: unknown): Theme => (isTheme(value) ? value : DEFAULT_THEME);

export const applyTheme = (theme: Theme): void => {
  const root = document.documentElement;
  // Mute transitions during the swap so the UI recolors at once (next-themes' disableTransitionOnChange).
  root.classList.add('theme-changing');
  root.setAttribute('data-theme', theme);
  root.getBoundingClientRect(); // reflow: commit colors before re-enabling transitions
  root.classList.remove('theme-changing');
  // Lets the server apply the theme before first paint (max-age = 1 year).
  document.cookie = `${THEME_COOKIE}=${theme}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
};
